export default "__VITE_ASSET__b6A6sFzo__"